export const WORKFLOW_STATUS = {
    CREATED: 'CREATED',
    READY_FOR_REVIEW: 'READY_FOR_REVIEW',
    PENDING_REVIEW: 'PENDING_REVIEW',
    CLOSED: 'CLOSED'
};

export const VERIFICATION_STATUS = {
    NONE: 'NONE',
    PENDING: 'PENDING',
    APPROVED: 'APPROVED',
    REJECTED: 'REJECTED',
    SYSTEM_ERROR: 'SYSTEM_ERROR',
    IGNORED: 'IGNORED'
};

export const DOCUMENT_FILTER_ERROR_CODES = ['441', '442', '443', '444', '445'];